/**
 * env.js 为默认的env配置， 其它env.xxx.js 对env.js进行扩展。
 **/
export default {
  env: 'prod', // 默认线上配置
  FLEET_APP_ENV: 'production',
  FLEET_PUBLIC_URL:
    '//img0.didiglobal.com/static/ibt_fe_marketing/global-fe/marketing-group/global-auto-solutions/fleet-app/',
  FLEET_APP_API_ENV: 'https://fms-union.didiglobal.com',
  FLEET_APP_OLD_API_ENV: 'https://fms-union.didiglobal.com',
  FLEET_OB_DRIVER_PAGE: 'https://page.didiglobal.com/driver-page/register/index.html',
  FLEET_OB_CAR_PAGE: 'https://page.didiglobal.com/driver-page/mycars/index.html',
  FLEET_OB_DOCUMENT_PAGE: 'https://page.didiglobal.com/driver-page/document-expired/index.html',
  FLEET_OLD_PAGE: 'https://fleetmobile.didiglobal.com/#/mobile',
  FLEET_DRIVER_INFO_PAGE:
    'https://page.didiglobal.com/global/driver/apps/dinfo/driver-info/index.html',
  FLEET_FEEDBACK_PAGE: 'https://page.didiglobal.com/global/quickbolt/page/online',
  FLEET_MATCHING_PAGE: 'https://fleet-matching-us.didiglobal.com/#/driver/center',
  FLEET_OB_AUDIT_PROGRESS: 'https://page.didiglobal.com/driver-page/register/index.html',
  FLEET_APP2_PAGE: 'https://fleetapp.didiglobal.com/',
  FLEET_PAY_PAYGE:
    'https://page.didiglobal.com/global/driver-wallet/repayment_pay/repayment_pay.html',
  FLEET_PAY_API: 'https://pay.didiglobal.com',
  FLEET_ADD_BANK:
    'https://page.didiglobal.com/global/driver-wallet/latin_bank_account/latin_bank_account.html',
  FLEET_MX_ADD_BANK: 'https://page.didiglobal.com/global/driver-wallet/bank_card/bank_card.html',
  FLEET_99_ADD_BANK:
    'https://page.99taxis.mobi/global/driver-wallet/bank_account/bank_account.html',
  FLEET_PAY_INVOICE: 'https://page.didiglobal.com/pay/pages/regulatory.html',
  FLEET_DRIVER_INFO_CITY: 'https://page.didiglobal.com/global/driver/apps/dinfo/upt-city/index.html'
};
